import { render } from "./MelatiDetail.vue?vue&type=template&id=415786ab&scoped=true&ts=true"
import script from "./MelatiDetail.vue?vue&type=script&lang=ts"
export * from "./MelatiDetail.vue?vue&type=script&lang=ts"

import "./MelatiDetail.vue?vue&type=style&index=0&id=415786ab&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415786ab"]])

export default __exports__